import React, { useEffect } from "react";
import data from '../../../../../Operation/data.json';
import qrimage from '../../../../utils/image/qrimage.png';

const PrintOrderHistoryBill = ({ order, institutionData, screenWidth, onClose }) => {
  const { printerpaperSize } = data;

  // Calculate totals based on provided order items
  const items = order.items || [];
  const billSubtotal = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const cgstRate = 2.5;
  const sgstRate = 2.5;
  const serviceTaxRate = institutionData?.serviceTax !== undefined ? institutionData.serviceTax : 0;

  const calculatedCgst = (billSubtotal * cgstRate) / 100;
  const calculatedSgst = (billSubtotal * sgstRate) / 100;
  const calculatedServiceTax = (billSubtotal * serviceTaxRate) / 100;
  let calculatedTotal;
  if (institutionData.cgst === 0 || institutionData.sgst === 0) {
    calculatedTotal = Math.round(billSubtotal);
  } else {
    calculatedTotal = Math.round(billSubtotal + calculatedCgst + calculatedSgst + calculatedServiceTax);
  }

  const printBill = () => {
    // Clean up any existing print area or styles
    const existingPrintArea = document.getElementById("printArea");
    if (existingPrintArea) document.body.removeChild(existingPrintArea);
    const existingStyle = document.querySelector("#printAreaStyle");
    if (existingStyle) document.head.removeChild(existingStyle);

    const formatDateTime = () => {
      const date = new Date(order.createdAt);
      return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }).replace(",", "");
    };

    if (!order || !order.tableName || !order.orderId) {
      console.error("Invalid order information.");
      onClose();
      return;
    }

    // Calculate total quantity from items
    const totalQty = items.reduce((sum, item) => sum + item.quantity, 0);

    const qrImageSrc = qrimage || '';
    
    const proceedWithPrint = () => {
 if (printerpaperSize === "80") {
      const subtotalRow = (institutionData.cgst === 0 || institutionData.sgst === 0)
        ? ''
        : `<div class="summary-row">
            <span>Subtotal:</span>
            <span>₹${billSubtotal.toFixed(2)}</span>
          </div>`;
      const itemsHTML = items
        .map(
          (item) => `
            <tr>
              <td class="item-name">${item.name}</td>
              <td class="item-qty">${item.quantity}</td>
              <td class="item-rate">₹${item.price % 1 === 0 ? item.price : item.price.toFixed(2)}</td>
              <td class="item-total">₹${(item.price * item.quantity) % 1 === 0 ? item.price * item.quantity : (item.price * item.quantity).toFixed(2)}</td>
            </tr>
          `
        )
        .join("");
      const qrSectionHTML = institutionData?.institution === "bhuk2323"
        ? `
          <div class="qr-section">
            <img src="${qrImageSrc}" alt="QR Code" class="qr-image"/>
            <p class="qr-text">Scan and Pay</p>
          </div>
        `
        : '';

      // Create print area
      const printArea = document.createElement("div");
      printArea.id = "printArea";
      printArea.innerHTML = `
        <div class="bill-container">
          <div class="bill-header">
            <h1>${institutionData?.companyName || "Restaurant Name"}</h1>
            <p class="address">${institutionData?.Query_Address || "Restaurant Address"}</p>
            <div class="contact-info">
              <div>Contact: ${institutionData?.Query_PhoneNumber || "N/A"}</div>
              <div>${formatDateTime()}</div>
            </div>
            ${institutionData?.gstin ? `<div class="gstin">GSTIN: ${institutionData.gstin}</div>` : ""}
            <div class="order-id">Order ID: ${order.orderId}</div>
          </div>

          <div class="bill-details">
            <div class="table-info">Table: ${order.tableName}</div>
          </div>

          <table class="items-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Qty</th>
                <th>Rate</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              ${itemsHTML}
            </tbody>
          </table>

          <div class="bill-summary">
            <div class="summary-row">
              <span>Total Qty:</span>
              <span>${totalQty}</span>
            </div>
            ${subtotalRow}
            <div class="summary-row">
              <span>CGST (${cgstRate}%):</span>
              <span>₹${calculatedCgst.toFixed(2)}</span>
            </div>
            <div class="summary-row">
              <span>SGST (${sgstRate}%):</span>
              <span>₹${calculatedSgst.toFixed(2)}</span>
            </div>
            ${serviceTaxRate > 0 ? `
            <div class="summary-row">
              <span>Service Tax (${serviceTaxRate}%):</span>
              <span>₹${calculatedServiceTax.toFixed(2)}</span>
            </div>` : ''}
            <div class="summary-row grand-total">
              <span><b>Total(Including Taxes):</b></span>
              <span><b>₹${calculatedTotal.toFixed(2)}</b></span>
            </div>
          </div>

          <div class="bill-footer">
            <p>Thank you, visit again!</p>
            <p>Empower your business with tekkzy.com</p>
            ${qrSectionHTML}
          </div>
        </div>
      `;
      document.body.appendChild(printArea);

      // Add print styles
      const style = document.createElement("style");
      style.id = "printAreaStyle";
      style.innerHTML = `
        @media print {
          @page {
            size: 80mm auto;
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
          }
          body * {
            visibility: hidden;
          }
          #printArea, #printArea * {
            visibility: visible;
          }
          #printArea {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 80mm;
            page-break-inside: avoid;
          }
        }

        .bill-container {
          font-family: 'Arial', 'Helvetica', sans-serif;
          font-weight: 500;
          max-width: 80mm;
          margin: 0;
          padding: 2mm 1mm;
          box-sizing: border-box;
          font-size: 11pt;
          line-height: 1.3;
          color: #000;
        }
        .bill-header {
          text-align: center;
          margin-bottom: 4mm;
          border-bottom: 1px dashed #000;
          padding-bottom: 2mm;
        }
        .bill-header h1 {
          margin: 0 0 1mm 0;
          font-size: 16pt;
          font-weight: bold;
          font-family: 'Arial Black', 'Arial', sans-serif;
        }
        .bill-header .address {
          margin: 1mm 0;
          font-size: 10pt;
          font-weight: 400;
        }
        .contact-info {
          font-size: 10pt;
          margin-bottom: 1mm;
          text-align: center;
          line-height: 1.3;
          font-weight: 500;
        }
        .gstin, .order-id {
          font-size: 10pt;
          text-align: center;
          font-weight: 500;
        }
        .bill-details {
          margin-bottom: 2mm;
          font-weight: bold;
          border-bottom: 1px dashed #000;
          padding-bottom: 1mm;
          font-size: 11pt;
        }
        .items-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 2mm;
          font-size: 10pt;
          font-family: 'Arial', sans-serif;
          font-weight: 500;
        }
        .items-table thead {
          border-bottom: 1px solid #000;
        }
        .items-table th, .items-table td {
          padding: 0.5mm;
          text-align: left;
        }
        .items-table th {
          font-weight: bold;
          background-color: #f5f5f5;
          font-size: 10pt;
        }
        .items-table td {
          font-size: 10pt;
          font-weight: 500;
        }
        .item-name { 
          width: 42%; 
          word-wrap: break-word;
          font-weight: 600;
          font-size: 12pt;
        }
        .item-qty { 
          width: 18%; 
          text-align: center; 
          font-weight: bold;
          font-size: 12pt;
        }
        .item-rate { 
          width: 20%; 
          text-align: right; 
          font-weight: 500;
        }
        .item-total { 
          width: 20%; 
          text-align: right; 
          font-weight: bold;
        }
        .bill-summary {
          margin-top: 2mm;
          font-size: 10pt;
          font-weight: 500;
        }
        .summary-row {
          display: flex;
          justify-content: space-between;
          padding: 0.5mm 0;
          border-bottom: 1px dashed #ddd;
          font-weight: 500;
        }
        .grand-total {
          font-weight: bold;
          border-bottom: none;
          border-top: 2px solid #000;
          padding-top: 1mm;
          font-size: 12pt;
          margin-top: 1mm;
        }
        .bill-footer {
          text-align: center;
          margin-top: 3mm;
          font-size: 9pt;
          border-top: 1px dashed #000;
          padding-top: 2mm;
          font-weight: 500;
          line-height: 1.4;
        }
        .qr-section {
          margin-top: 3mm;
          text-align: center;
        }
        .qr-image {
          max-width: 80mm;
          max-height: 40mm;
          margin: 2mm auto;
          display: block;
        }
        .qr-text {
          font-size: 10pt;
          font-weight: bold;
          margin: 1mm 0 0 0;
        }
      `;
      document.head.appendChild(style);
    } else {
      const subtotalRow = (institutionData.cgst === 0 || institutionData.sgst === 0)
        ? ''
        : `<tr><td><b>Subtotal:</b></td><td>₹${billSubtotal.toFixed(2)}</td></tr>`;
      const itemsHTML = items
        .map(
          (item) => `
            <tr>
              <td>${item.name}</td>
              <td style="text-align: center;">${item.quantity}</td>
              <td style="text-align: right;">${item.price % 1 === 0 ? `₹${item.price}` : `₹${item.price.toFixed(2)}`}</td>
              <td style="text-align: right;">${(item.price * item.quantity) % 1 === 0 ? `₹${item.price * item.quantity}` : `₹${(item.price * item.quantity).toFixed(2)}`}</td>
            </tr>
          `
        )
        .join("");

      // Create print area
      const printArea = document.createElement("div");
      printArea.id = "printArea";
      printArea.innerHTML = `
        <div class="bill">
          <div class="header">${institutionData?.companyName || ""}</div>
          <div class="sub-header">${institutionData?.Query_Address || ""}</div>
          <div class="info">Contact: ${institutionData?.Query_PhoneNumber || ""}<br>Date: ${formatDateTime()}</div>
          ${institutionData?.gstin ? `<div class="info">GSTIN: ${institutionData.gstin}</div>` : ""}
          <div class="info">Order ID: ${order.orderId}</div>
          <div class="divider"></div>
          <div><b>Table:</b> ${order.tableName}</div>
          <div class="divider"></div>
          <table class="table" style="width: 100%; border-collapse: collapse; font-family: Arial, sans-serif; table-layout: fixed;">
            <tr style="border-bottom: 2px solid #000; background-color: #f2f2f2; font-size: 10px;">
              <th style="text-align: left; padding: 8px; width: 40%;">Item</th>
              <th style="text-align: center; padding: 8px; width: 20%;">Qty</th>
              <th style="text-align: right; padding: 8px; width: 20%;">Rate</th>
              <th style="text-align: right; padding: 8px; width: 20%;">Total</th>
            </tr>
            ${itemsHTML}
          </table>
          <div class="divider"></div>
          <table class="totals">
            <tr><td><b>Total Qty:</b></td><td>${totalQty}</td></tr>
            ${subtotalRow}
            <tr><td>CGST (${cgstRate}%):</td><td>₹${calculatedCgst.toFixed(2)}</td></tr>
            <tr><td>SGST (${sgstRate}%):</td><td>₹${calculatedSgst.toFixed(2)}</td></tr>
            <tr><td>Service Tax (${serviceTaxRate}%):</td><td>₹${calculatedServiceTax.toFixed(2)}</td></tr>
            <tr class="total(Rounded)"><td><b>Grand Total:</b></td><td>₹${calculatedTotal.toFixed(2)}</td></tr>
          </table>
          <div class="divider"></div>
          <div class="footer">Thank you for visiting!<br>Empowered the Business with tekkzy.com</div>
        </div>
      `;
      document.body.appendChild(printArea);

      // Add print styles
      const style = document.createElement("style");
      style.id = "printAreaStyle";
      style.innerHTML = screenWidth <= 1025
        ? `
          @media print {
            @page { size: 58mm auto; margin: 0; }
            body { margin: 0; padding: 0; }
            body * { visibility: hidden; }
            #printArea, #printArea * { visibility: visible; }
            #printArea { position: absolute; top: 0; left: 50%; transform: translateX(-50%); width: 58mm; padding: 4mm; page-break-inside: avoid; }
          }
          .bill { font-family: monospace; font-size: 12px; line-height: 1.1; padding: 2px; text-align: left; max-width: 54mm; word-wrap: break-word; margin: 0 auto; }
          .header { font-size: 12px; font-weight: bold; text-align: center; }
          .table { font-size: 10px; }
          .sub-header, .info, .footer { font-size: 12px; text-align: center; }
          .divider { border-top: 1px dashed black; margin: 2px 0; }
          .table, .totals { width: 100%; border-collapse: collapse; font-size: 12px; }
          .table th, .table td, .totals td { padding: 1px; word-break: break-word; }
          .table th { text-align: center; }
          .grand-total { font-weight: bold; border-top: 1px solid black; font-size: 16px; }
        `
        : `
          @media print {
            @page { size: 58mm auto; margin: 0; }
            body { margin: 0; padding: 0; }
            body * { visibility: hidden; }
            #printArea, #printArea * { visibility: visible; }
            #printArea { position: absolute; top: 0; left: 50%; transform: translateX(-50%); width: 58mm; padding: 2mm; page-break-inside: avoid; }
          }
          .bill { font-family: monospace; font-size: 14px; line-height: 1.1; padding: 2px; text-align: left; max-width: 58mm; word-wrap: break-word; margin: 0 auto; }
          .header { font-size: 14px; font-weight: bold; text-align: center; }
          .table { font-size: 10px; }
          .sub-header, .info, .footer { font-size: 14px; text-align: center; }
          .divider { border-top: 1px dashed black; margin: 2px 0; }
          .table, .totals { width: 100%; border-collapse: collapse; font-size: 14px; }
          .table th, .table td, .totals td { padding: 1px; word-break: break-word; }
          .table th { text-align: center; }
          .grand-total { font-weight: bold; border-top: 1px solid black; font-size: 16px; }
        `;
      document.head.appendChild(style);
    }

    setTimeout(() => {
      window.print();
    }, 500);

      window.onafterprint = () => {
      document.body.removeChild(printArea);
      document.head.removeChild(style);
      onClose();
      };
      
      // Fallback cleanup
      setTimeout(() => {
        const existingPrintArea = document.getElementById("printArea");
        if (existingPrintArea) existingPrintArea.remove();
        const existingStyle = document.getElementById("printAreaStyle");
        if (existingStyle) existingStyle.remove();
        onClose();
      }, 1500);
    };

    if (institutionData?.institution === "bhuk2323" && qrImageSrc) {
      const img = new Image();
      img.onload = () => {
        console.log("QR image loaded successfully");
        proceedWithPrint();
      };
      img.onerror = () => {
        console.warn("QR image failed to load, proceeding with print anyway");
        proceedWithPrint();
      };
      img.src = qrImageSrc;
    } else {
      proceedWithPrint();
    }
  };

  useEffect(() => {
    printBill();
  }, []);

  return null;
};

export default PrintOrderHistoryBill;